// extracted by mini-css-extract-plugin
export var component = "TableModule-module--component--wi3AX";
export var head = "TableModule-module--head--b4lST";
export var table = "TableModule-module--table--fei7W";
export var td = "TableModule-module--td--PDItq";
export var th = "TableModule-module--th--ftR59";
export var title = "TableModule-module--title--bpedx";